import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import Navigation from './components/Navigation';
import SiteFooter from './sections/SiteFooter';
import DemoRequestModal from './components/DemoRequestModal';
import DemoModal from './components/DemoModal';
import { DEMO_CHOICE, VITRINE_BASE } from './constants';
import { LanguageProvider, useLanguage } from './LanguageContext';
import './PitboardSite.css';

function DemoChoiceContent() {
  const { lang } = useLanguage();
  const t = DEMO_CHOICE[lang];

  const [modalVersion, setModalVersion] = useState(null); // null | 'courtier' | 'compagnie'

  // ── SEO basique ──
  useEffect(() => {
    const prevTitle = document.title;
    document.title = lang === 'fr'
      ? 'Tester PitBoard — Courtier ou Compagnie | PitBoard Suite'
      : 'Try PitBoard — Broker or Insurer | PitBoard Suite';
    return () => { document.title = prevTitle; };
  }, [lang]);

  return (
    <div className="pitboard-site" data-testid="pb-demo-choice-page">
      <Navigation />
      <main>
        <section
          className="pb-section pb-section-pad pb-in-view"
          style={{ minHeight: '100vh', paddingTop: 120 }}
        >
          <div className="pb-container">

            {/* ─── En-tête ─── */}
            <div style={{ marginBottom: 64, maxWidth: 600 }}>
              <div className="pb-label">{t.label}</div>
              <h1 className="pb-section-title">{t.title}</h1>
              <p className="pb-section-sub">{t.sub}</p>
            </div>

            {/* ─── Cartes de choix ─── */}
            <div className="pb-demo-choice-grid">

              {/* Courtier */}
              <div
                className="pb-demo-choice-card"
                data-testid="pb-demo-choice-courtier"
              >
                <div className="pb-demo-choice-tag pb-demo-choice-tag--courtier">
                  {t.courtier.tag}
                </div>
                <h2 className="pb-demo-choice-title">{t.courtier.title}</h2>
                <p className="pb-demo-choice-desc">{t.courtier.desc}</p>
                <ul className="pb-demo-choice-list">
                  {t.courtier.features.map((f, i) => (
                    <li key={i} className="pb-demo-choice-feature">
                      <Check size={14} strokeWidth={2.5} />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="pb-demo-choice-footer">
                  <button
                    className="pb-btn-outline pb-demo-choice-cta"
                    data-testid="pb-demo-choice-courtier-btn"
                    onClick={() => setModalVersion('courtier')}
                  >
                    {t.courtier.cta}
                    <ArrowRight size={15} />
                  </button>
                </div>
              </div>

              {/* Compagnie */}
              <div
                className="pb-demo-choice-card pb-demo-choice-card--featured"
                data-testid="pb-demo-choice-compagnie"
              >
                <div className="pb-demo-choice-tag pb-demo-choice-tag--compagnie">
                  {t.compagnie.tag}
                </div>
                <h2 className="pb-demo-choice-title">{t.compagnie.title}</h2>
                <p className="pb-demo-choice-desc">{t.compagnie.desc}</p>
                <ul className="pb-demo-choice-list">
                  {t.compagnie.features.map((f, i) => (
                    <li key={i} className="pb-demo-choice-feature">
                      <Check size={14} strokeWidth={2.5} />
                      {f}
                    </li>
                  ))}
                </ul>
                <div className="pb-demo-choice-footer">
                  <button
                    className="pb-btn-primary pb-demo-choice-cta"
                    data-testid="pb-demo-choice-compagnie-btn"
                    onClick={() => setModalVersion('compagnie')}
                  >
                    {t.compagnie.cta}
                    <ArrowRight size={15} />
                  </button>
                </div>
              </div>

            </div>

            {/* ─── Note sur mesure ─── */}
            <div className="pb-demo-choice-note" data-testid="pb-demo-choice-note">
              <span className="pb-demo-choice-note-highlight">{t.note.highlight}</span>
              {' '}{t.note.text}
            </div>

          </div>
        </section>
      </main>
      <SiteFooter />
      {/* Formulaire de demande de démo (bouton du haut / Navigation) */}
      <DemoModal />
      {/* ─── Modale de qualification prospect ─── */}
      {modalVersion && (
        <DemoRequestModal
          version={modalVersion}
          onClose={() => setModalVersion(null)}
        />
      )}
    </div>
  );
}

export default function DemoChoicePage() {
  return (
    <LanguageProvider>
      <DemoChoiceContent />
    </LanguageProvider>
  );
}
